import { useEffect } from 'react';

/**
 * Custom hook to manage the browser document title
 *
 * Automatically appends " - Kirin" as a suffix so the most-significant info
 * (the page name) appears first and is still visible when the browser tab
 * caption is truncated. Falls back to plain "Kirin" when the title is empty.
 *
 * @param title - The page title to display (will be suffixed with " - Kirin")
 *
 * @example
 * useDocumentTitle('Alerts')  // Sets document.title to "Alerts - Kirin"
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    // Set the new title with " - Kirin" suffix so the page name is leading.
    document.title = title ? `${title} - Kirin` : 'Kirin';
  }, [title]);
}
